import { useQuery } from '@tanstack/react-query'

import { getApiClient } from '@/lib/api'

const MEETING_CENTER_KEYS = {
  all: ['meeting-center'] as const,
  latest: (workspaceId: string) =>
    [...MEETING_CENTER_KEYS.all, 'latest', workspaceId] as const,
  history: (workspaceId: string) =>
    [...MEETING_CENTER_KEYS.all, 'history', workspaceId] as const,
  snapshot: (workspaceId: string, snapshotId: string | null) =>
    [...MEETING_CENTER_KEYS.all, 'snapshot', workspaceId, snapshotId] as const,
}

export function useMeetingCenterLatest(workspaceId: string) {
  return useQuery({
    queryKey: MEETING_CENTER_KEYS.latest(workspaceId),
    queryFn: () => getApiClient().getMeetingCenterLatest(workspaceId),
    enabled: workspaceId.length > 0,
    staleTime: 60 * 1000,
  })
}

export function useMeetingCenterHistory(workspaceId: string) {
  return useQuery({
    queryKey: MEETING_CENTER_KEYS.history(workspaceId),
    queryFn: () => getApiClient().getMeetingCenterHistory(workspaceId),
    enabled: workspaceId.length > 0,
    staleTime: 60 * 1000,
  })
}

export function useMeetingCenterSnapshot(
  workspaceId: string,
  snapshotId: string | null,
) {
  return useQuery({
    queryKey: MEETING_CENTER_KEYS.snapshot(workspaceId, snapshotId),
    queryFn: () => getApiClient().getMeetingCenterSnapshot(workspaceId, snapshotId!),
    enabled: workspaceId.length > 0 && snapshotId !== null,
    staleTime: 60 * 1000,
  })
}
